import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import BucketApi from "api/bucketApi";
import ProcesosApi from "api/procesosApi";

function CardAnexos({ proceso }) {
  const [anexosUrls, setAnexosUrls] = useState([]);
  const [bienes, setBienes] = useState([]);
  const [personas, setPersonas] = useState([]);

  useEffect(() => {
    async function cargarPersonas() {
      if (!proceso?.id) return;
      try {
        const respPersonas = await ProcesosApi.obtenerPersonasCargo(proceso.id);
        setPersonas(respPersonas.data || []);
      } catch (error) {
        console.error("Error al cargar personas:", error);
        setPersonas([]);
      }
    }
    cargarPersonas();
  }, [proceso]);

  useEffect(() => {
    async function cargarBienes() {
      if (!proceso?.id) return;
      try {
        const respBienes = await ProcesosApi.obtenerBienesProceso(proceso.id);
        setBienes(respBienes.data?.bienes || []);
      } catch (error) {
        console.error("Error al cargar bienes:", error);
        setBienes([]);
      }
    }
    cargarBienes();
  }, [proceso]);

  useEffect(() => {
    //if (personas.length === 0 && bienes.length === 0) return;
    const fetchAnexos = async () => {
      try {
        const anexos = [
          { name: "Cédula Cliente", file: "cedula_cliente.pdf" },
          { name: "Firma Cliente", file: "firma_cliente.jpg" },
          ...(personas?.length
            ? personas.map((persona) => ({
                name: `Persona A Cargo ${persona.nombre_completo}`,
                file: `persona_${persona.nombre_completo.replace(/\s+/g, "_").toLowerCase()}.pdf`,
              }))
            : []),
          ...(bienes?.length
            ? bienes
                .map((bien) => {
                  const anexosBien = [];
                  if (bien.placa) {
                    anexosBien.push({
                      name: `Bien Mueble ${bien.placa}`,
                      file: `tarjeta_propiedad_${bien.placa}.pdf`,
                    });
                  }
                  if (bien.matricula_inmobiliaria) {
                    anexosBien.push({
                      name: `Bien Inmueble ${bien.matricula_inmobiliaria}`,
                      file: `certificado_tradicion_${bien.matricula_inmobiliaria}.pdf`,
                    });
                  }
                  return anexosBien;
                })
                .flat()
            : []),
          { name: "Carta Laboral", file: "carta_laboral.pdf" },
          { name: "Certificado Ingresos", file: "certificacion_ingresos.pdf" },
        ];
        const anexosUrlsPromises = anexos.map(async (anexo) => {
          try {
            //const response = await BucketApi.getSolicitudFileUrl(anexo.file, proceso.identificador);
            const response = await BucketApi.getSolicitudFileUrlFresh(
              anexo.file,
              proceso.identificador
            );
            return { ...anexo, url: response.data.file_url, exist: response.data.exists };
          } catch (error) {
            console.error(`Error obteniendo ${anexo.file}:`, error);
            return { ...anexo, url: null };
          }
        });
        const anexosData = await Promise.all(anexosUrlsPromises);
        setAnexosUrls(anexosData);
      } catch (error) {
        console.error("Error obteniendo anexos:", error);
      }
    };

    fetchAnexos();
  }, [proceso, personas, bienes]);

  return (
    <Card sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", p: 2 }}>
      <Grid container spacing={2}>
        {anexosUrls.map((anexo, index) => (
          <Grid size={6} key={index}>
            <Typography variant="h5">{anexo.name}</Typography>
            {anexo.exist ? (
              anexo.file.endsWith(".pdf") ? (
                <embed
                  src={anexo.url}
                  type="application/pdf"
                  width="100%"
                  height="250px"
                  style={{ border: "1px solid #ddd", borderRadius: "5px" }}
                />
              ) : (
                <img
                  src={anexo.url}
                  alt={anexo.name}
                  style={{
                    maxWidth: "200px", // Reduce el tamaño de la imagen
                    maxHeight: "150px", // Ajusta la altura para evitar imágenes muy grandes
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    display: "block",
                    margin: "10px auto", // Centra la imagen
                  }}
                />
              )
            ) : (
              <Typography variant="body2" color="error">
                No disponible
              </Typography>
            )}
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

CardAnexos.propTypes = {
  proceso: PropTypes.object.isRequired,
};

export default CardAnexos;
